import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { commonString } from "../../../../../../AdminApi/commFunc";
import { useApi } from "../../../../../../hooks/useApi";
import Loader from "../../../../../DefaultStyles/Loader";
import { Textarea } from "../../../../../Input/Textarea";
import AlertModal from "../../../../../Modal/AlertModal";
import DefaultModalLayout from "../../../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../../Users/UserDetail/CommentModal/TargetContainer";

interface FaqDeleteModalProps extends DefaultModalCommonProps {}

export default function FaqDeleteModal({ closeEvent }: FaqDeleteModalProps) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { faqId, noticeId, termsId } = useParams();

  const isFaq = Boolean(pathname.includes("faq"));
  const isNotice = Boolean(pathname.includes("notice"));

  const title = commonString(pathname).title;
  const paramsId = isFaq ? faqId : isNotice ? noticeId : termsId;

  const [reason, setReason] = useState("");
  const [deleteAskModal, setDeleteAskModal] = useState(false);
  const [remove, setRemove] = useState(false);

  const { response, error, loading } = useApi({
    method: "delete",
    url: remove ? `${isFaq ? "FAQ" : "notice"}/${paramsId}` : undefined,
    data: isFaq
      ? {
          reason,
        }
      : {
          reason,
          isNotice: isNotice ? 1 : 0,
        },
  });

  useEffect(() => {
    if (response?.status === 200) {
      toast.success(`${title}이 삭제 되었습니다.`);
      closeEvent();
      navigate(`/linkid-manage/${commonString(pathname).route}`);
    }
  }, [response, title]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? `${title} 삭제에 실패하였습니다.`);
      setRemove(false);
    }
  }, [error, title]);

  return (
    <>
      <DefaultModalLayout
        type="input"
        modalTitle={`${title} 삭제`}
        closeEvent={closeEvent}
        confirmEvent={() => setDeleteAskModal(true)}
        confirmDisabled={reason === ""}
        isSmallModal={true}
        isDeleteModal={true}
      >
        <>
          <ModalLabel>삭제 사유</ModalLabel>

          <Textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="직접 입력(100글자 이내)"
          />
        </>
      </DefaultModalLayout>

      {loading && <Loader />}

      {deleteAskModal && (
        <AlertModal
          title={`해당 ${title}이 즉시 삭제됩니다.
      계속 하시겠습니까?`}
          cancelEvent={() => setDeleteAskModal(false)}
          confirmEvent={() => {
            setRemove(true);
            setDeleteAskModal(false);
          }}
        />
      )}
    </>
  );
}
